import React, { useEffect, useState } from "react";
import UploadIcon from "@mui/icons-material/Upload";

import styles from "./Banner.module.css";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosConfig } from "../../../../axios/axiosConfig";
import BannerImageTable from "./BannerImageTable";
import toast from "react-hot-toast";
import MuiLoadingSpinner from "../../../common/MuiLoadingSpinner";
import axios from "axios";

const Banner = () => {
  const [imgFile, setImgFile] = useState();
  const [imgPreview, setImgPreview] = useState(null);

  const [formInput, setFormInput] = useState({
    imgUrl: "", // blob preview url
    customUrl: "",
    targetUrl: "",
    screen_name: "",
  });

  const [bannerImagesList, setBannerImagesList] = useState([]);
  const [screenOptions, setScreenOptions] = useState([]);
  const [isScreenLoading, setIsScreenLoading] = useState(false);
  const queryClient = useQueryClient();

  // Fetch all screens for the dropdown
  useEffect(() => {
 const fetchScreens = async () => {
  setIsScreenLoading(true);
  try {
    const response = await axiosConfig({
      method: "get",
      url: "/advertisement/screens/list",
    });

    setScreenOptions(response?.data?.response || []);
  } catch (error) {
    const errMsg =
      error?.response?.data?.response || error.message || "Something went wrong";
    toast.error(errMsg);
  } finally {
    setIsScreenLoading(false);
  }
};
    fetchScreens();
  }, []);

  // f;etch all banner images
  const fetchBannerImagesQuery = useQuery({
    retry: false,
    refetchOnWindowFocus: false, // Prevent refetch on window focus
    refetchInterval: false, // Disable automatic refetching
    queryKey: ["banner-images"], // dependency
    queryFn: () => fetchBannerImages(),
    onSuccess: (data) => {
      setBannerImagesList(data.response);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.response || "Something went wrong");
    },
  });

  const handleFormInputOnChange = (event) => {
    setFormInput((prevState) => {
      return {
        ...prevState,
        [event.target.name]: event.target.value,
      };
    });

    // image preview code
    if (event.target.name === "imgUrl") {
      setImgPreview(event.target.value);
    }
  };

  function handleImageFileChange(e) {
    setImgPreview(URL.createObjectURL(e.target.files[0]));
    setImgFile(e.target.files[0]);

    setFormInput((prev) => {
      return {
        ...prev,
        // imgUrl: URL.createObjectURL(e.target.files[0]),
        imgUrl: e.target.files[0]?.name,
      };
    });
  }

  // upload home banner
  const uploadHomeBannerMutation = useMutation({
    mutationFn: (variables) => uploadHomeBanner(formInput, imgFile),
    onSuccess: (data) => {
      // setBannerImagesList()
      toast.success("Image uploaded successfully!");
      queryClient.invalidateQueries(["banner-images"]);
      setFormInput({
        imgUrl: "",
        customUrl: "",
        targetUrl: "",
        screen_name: "",
      });
      setImgFile(null);
      setImgPreview(null);
    },
    onError: (error) => {
      alert(error?.response?.data?.response);
    },
    onSettled: (data) => {},
  });

  // HANDLE SUBMIT
  const handleSubmit = (e) => {
    // e.preventDefault();
    if (!imgFile || !formInput.screen_name) {
      toast.error("Please select an image and a screen");
      return;
    }
    uploadHomeBannerMutation.mutate();
  };

  return (
    <div>
      {/* Form + Preview row */}
      <div className={styles.formPreviewContainer}>
        {/* Banner Form card */}
        <div className={styles.bannerForm}>
          <div className={styles.formHeader}>
            <UploadIcon style={{ color: "#b8d4c4", fontSize: 18 }} />
            <p className={styles.formHeaderTitle}>Upload Banner</p>
          </div>

          <div className={styles.formBody}>
            {/* Image file */}
            <div className={styles.inputBox}>
              <label htmlFor="imgUrl">Image File</label>
              <div className={styles.imgUploadContainer}>
                <input
                  disabled
                  className={styles.imgUrlInput}
                  type="text"
                  name="imgUrl"
                  id="imgUrl"
                  value={formInput.imgUrl}
                  placeholder="No file chosen"
                  onChange={handleFormInputOnChange}
                />
                <label htmlFor="imageUpload" className={styles.uploadLabel}>
                  <UploadIcon style={{ fontSize: 16 }} />
                  <input
                    onChange={handleImageFileChange}
                    className={styles.imgFileInput}
                    type="file"
                    name="imageUpload"
                    id="imageUpload"
                  />
                </label>
              </div>
            </div>

            {/* Custom URL */}
            <div className={styles.inputBox}>
              <label htmlFor="customUrl">Custom Link</label>
              <input
                className={styles.inputControl}
                type="text"
                name="customUrl"
                id="customUrl"
                value={formInput.customUrl}
                placeholder="https://..."
                onChange={handleFormInputOnChange}
              />
            </div>

            {/* Target URL */}
            <div className={styles.inputBox}>
              <label htmlFor="targetUrl">Target Link</label>
              <input
                className={styles.inputControl}
                type="text"
                name="targetUrl"
                id="targetUrl"
                value={formInput.targetUrl}
                placeholder="https://..."
                onChange={handleFormInputOnChange}
              />
            </div>

            {/* Screen Name */}
            <div className={styles.inputBox}>
              <label htmlFor="screen_name">Screen Name</label>
              <select
                className={styles.inputControl}
                name="screen_name"
                id="screen_name"
                value={formInput.screen_name}
                onChange={handleFormInputOnChange}
                disabled={isScreenLoading}
              >
                <option value="" disabled>
                  {isScreenLoading ? "Loading screens..." : "Select Screen"}
                </option>
                {screenOptions &&
                  screenOptions.map((screen, id) => (
                    <option key={id} value={screen.screen_name}>
                      {screen.screen_name || "Unknown Screen"}
                    </option>
                  ))}
              </select>
            </div>

            <div className={styles.submitBtnContainer}>
              <button className={styles.submitBtn} onClick={handleSubmit}>
                {uploadHomeBannerMutation.isLoading ? "Uploading..." : "Upload Banner"}
              </button>
            </div>
          </div>
        </div>

        {/* Image Preview card */}
        <div className={styles.imgPreviewContainer}>
          <div className={styles.previewHeader}>
            <p className={styles.previewHeaderTitle}>Image Preview</p>
          </div>
          <div className={styles.imgContainer}>
            {imgPreview ? (
              <img className={styles.imgPreview} src={imgPreview} alt="Banner preview" />
            ) : (
              <p className={styles.noPreview}>No image selected yet.<br />Upload an image to see preview.</p>
            )}
          </div>
        </div>
      </div>

      {/* Banner Table */}
      <div style={{ marginTop: 24 }}>
        {fetchBannerImagesQuery?.isLoading ? (
          <MuiLoadingSpinner />
        ) : (
          <BannerImageTable
            bannerImagesList={bannerImagesList}
            setBannerImagesList={setBannerImagesList}
          />
        )}
      </div>
    </div>
  );
};

export default Banner;

// utilities
const uploadHomeBanner = async (form_input, img_file) => {
  // if (!ticket_id) return;

  const formData = new FormData();
  formData.append("image", img_file);
  formData.append("image_link", form_input?.customUrl);
  formData.append("jump_screen_link", form_input?.targetUrl);
  formData.append("screen_name", form_input?.screen_name); 


  const res = await axiosConfig({
    method: "post",
    url: "/home/banner",
    data: formData,
    // data: {
    //   image: img_file,
    //   image_link: form_input?.customUrl,
    //   jump_screen_link: form_input?.targetUrl,
    // },
  });

  return res.data;
};

// UTILITY FUNCTIONS
export const fetchBannerImages = async () => {
  // if (!USERID) return;

  const res = await axiosConfig({
    method: "get",
    url: "/home/banner",
    data: {},
  });

  return res.data;
};
